import WebModule from '../web_module'

export default class Admin extends WebModule

  @selector: '.modulor_web_module_admin'

# do not register since this is just superclass
